import fetch from "node-fetch"

import { get_cached_BSVUSD_price } from "./bsvusd.js"
import { getLog } from "./helpers.js"


// ---------- PARAMS -------------------------------

let cached_bsveur = 102.34              // default fallback value
let bsveur_update_every_ms = 10 * 60 * 1000    // update every 10 mins max

// -------------------------------------------------

let bsveur_lastupdate = 0 // timestamp


/**
 * using a synchronous, cached version strategy for most calls
 * allows us to answer instantly to keep a fast oracle
 * and update the cache in the background asynchronously for next calls
 */
export async function get_cached_BSVEUR_price() {
    const log = getLog("get_cached_BSVEUR_price")
    if (bsveur_lastupdate == 0) {
        // if we never did an update, we will have to force one even if this is not ideal
        // you should call this function on launch to avoid doing it when you have to answer fast
        log("FIRST TIME: need to update BSVEUR price")
        await update_cached_BSVEUR_price()
        bsveur_lastupdate = Date.now()
        log("FIRST TIME: set BSVEUR=", cached_bsveur)
        return cached_bsveur
    }
    else if (Date.now() - bsveur_lastupdate > bsveur_update_every_ms) {
        bsveur_lastupdate = Date.now()

        log("need to update BSVEUR price")

        // no await here to not block oracle ! we will update cache asynchronously
        update_cached_BSVEUR_price()
    }

    return cached_bsveur
}

async function update_cached_BSVEUR_price() {
    const log = getLog("update_cached_BSVEUR_price")
    try {
        let new_BSVEUR_price = await get_latest_BSVEUR_price()

        if (!isNaN(new_BSVEUR_price) && new_BSVEUR_price > 0) {
            log("Update BSVEUR price from", cached_bsveur, "to", new_BSVEUR_price)
            cached_bsveur = new_BSVEUR_price
        } else {
            log.error("got new_BSVEUR_price=", new_BSVEUR_price, ", abort update.")
        }
    } catch (e) {
        log.error("Error in update_cached_BSVEUR_price(): ", e)
    }
}

export function get_latest_BSVEUR_price() {
    const log = getLog("get_latest_BSVEUR_price")
    // strategy: if one fails we move to the next one
    // by order of how close they are to coinmarketcap's price:

    return new Promise((resolve, reject) => {
        log("fetching BSVEUR=bsvusd/eurusd from frankfurter...")
        get_BSVEUR_frankfurter().then(resolve).catch(e => {
            log("Error while fetching BSVEUR=bsvusd/eurusd price from frankfurter", e)
            log("fetching BSVEUR from CoinGecko...")
            get_BSVEUR_CoinGecko().then(resolve).catch(reject)
        })
    })
}

function get_BSVEUR_frankfurter() {

    // strategy: calculate  bsveur by doing bsveur=bsvusd/eurusd:

    const url = "https://api.frankfurter.dev/v2/rates?quotes=USD"

    return new Promise((resolve, reject) => {

        fetch(url).then(function(res) {
            if (res.status !== 200) {
                reject("Error while fetching frankfurter:", res.status)
                return;
            }
            return res.json()
        }).then(async (data) => {
            if (data && Array.isArray(data) && data.length > 0 && data[0].rate) {
                const eurusd = parseFloat(data[0].rate)
                console.log("get_BSVEUR_frankfurter(): eurusd=", eurusd)
                const bsvusd = await get_cached_BSVUSD_price()
                const bsveur = parseFloat(bsvusd / eurusd).toFixed(3)
                resolve(parseFloat(bsveur))
            }
            reject("Error while parsing response from frankfurter API, data=", data)
        }).catch(reject)
    })
}


function get_BSVEUR_CoinGecko() {
    const bsv_id = "bitcoin-cash-sv"
    const url = "https://api.coingecko.com/api/v3/simple/price?ids=" + bsv_id + "&vs_currencies=EUR"

    return new Promise((resolve, reject) => {
        fetch(url).then(function(res) {
            if (res.status !== 200) {
                reject("Error while fetching CoinGecko: ", res.status);
                return;
            }
            return res.json()
        }).then(data => {
            if (data[bsv_id] && data[bsv_id]["eur"]) {
                const price = Number(data[bsv_id]["eur"]);
                if (price > 0) {
                    resolve(price)
                    return;
                }
            }
            reject("Error while parsing response from coingecko API, data=", data);
        }).catch(reject)
    })
}
